import * as ACTION_TYPES from './types';

export function addModal({ type, data, id }) {
  return {
    type: ACTION_TYPES.MODAL_LIST_ADD,
    payload: {
      type,
      data,
      id,
    },
  };
}

export function removeModal(id) {
  return {
    type: ACTION_TYPES.MODAL_LIST_REMOVE,
    payload: {
      id,
    },
  };
}
export function clearModal() {
  return {
    type: ACTION_TYPES.MODAL_LIST_CLEAR,
  };
}
